import {
	CareClaimsQuery,
	useDeleteCareClaimMutation,
} from '../../../../graphql/graphql';
import styles from './DiscourseMedicalProceduresList.module.scss';
import React, { useMemo } from 'react';
import { QueryDataItem } from '../../../../Interfaces/QueryDataItem';
import useNotification from '../../../../Hooks/useNotification.hook';
import useApiClient from '../../../Base/Hooks/useApiClient';

interface Props {
	careClaimId: string;
	item: QueryDataItem<CareClaimsQuery['careClaims']>['medicalProcedure'];
	refetch: () => void;
}

const DiscourseMedicalProceduresListItem = ({
	careClaimId,
	item,
	refetch,
}: Props) => {
	const [deleteCareClaim] = useDeleteCareClaimMutation();
	const { showNotificationSuccess } = useNotification();
	const { showUnexpectedError, displayGQLError } = useApiClient();

	const label = useMemo(
		() => `${item.code}${item?.name ? ` - ${item.name}` : ''}`,
		[item],
	);

	const onDelete = async () => {
		try {
			const response = await deleteCareClaim({ id: careClaimId });

			if ('data' in response) {
				showNotificationSuccess({
					content: 'component.caseType.caseTypeRemoved',
				});
				refetch();
			} else {
				displayGQLError(response);
			}
		} catch (err) {
			showUnexpectedError();
		}
	};

	return (
		<div className={styles.item}>
			<div className={styles.label}>{label}</div>
			<button type='button' className={styles.removeButton} onClick={onDelete}>
				<img src='/dist/icons/xmark-solid-red.svg' alt='remove' />
			</button>
		</div>
	);
};

export default DiscourseMedicalProceduresListItem;
